import { render, staticRenderFns } from "./SocialSharer.vue?vue&type=template&id=46ff7ed7&scoped=true"
import script from "./SocialSharer.vue?vue&type=script&lang=ts"
export * from "./SocialSharer.vue?vue&type=script&lang=ts"
import style0 from "./SocialSharer.vue?vue&type=style&index=0&id=46ff7ed7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ff7ed7",
  null
  
)

export default component.exports